import {Fragment, useEffect, useState, useRef} from 'react'
import Chat from './Chat'
import Sidebar from './SidebarLeft'
import {useParams} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'
import {
    getChatContactsFromServer,
    getUserProfileFromServer
} from './store/actions'
import {BRANDS} from './store/actionTypes'
import '@styles/base/pages/app-chat.scss'
import '@styles/base/pages/app-chat-list.scss'

const AppChat = () => {
    const {id} = useParams()
    const dispatch = useDispatch()
    const chatBrandsStoreSlice = useSelector(state => state.chatBrands)

    const [user, setUser] = useState({})
    const [sidebar, setSidebar] = useState(false)
    const [userSidebarRight, setUserSidebarRight] = useState(false)
    const [userSidebarLeft, setUserSidebarLeft] = useState(false)

    const massMsgHandlerRef = useRef(null)

    const handleSidebar = () => setSidebar(!sidebar)
    const handleUserSidebarLeft = () => setUserSidebarLeft(!userSidebarLeft)
    const handleUserSidebarRight = () => setUserSidebarRight(!userSidebarRight)

    const handleUser = obj => setUser(obj)

    const handleTabChange = (tab) => {
        dispatch({type: BRANDS.SET_ACTIVE_CHAT_TAB, tab})
        dispatch(getChatContactsFromServer(tab))
    }

    const handleMassMessageClick = () => {
        if (massMsgHandlerRef.current) {
            massMsgHandlerRef.current()
        }
    }

    // On mount: fetch all 3 tabs so lists are ready without needing a tab click
    useEffect(() => {
        dispatch(getUserProfileFromServer())
        dispatch({type: 'CLEAR_CHAT_CONTENT_ON_LOAD'})
        dispatch({type: 'CLEAR_CHAT_CONTACT_ON_LOAD'})
        dispatch(getChatContactsFromServer('inbox'))
        dispatch(getChatContactsFromServer('sent'))
        dispatch(getChatContactsFromServer('archive'))
    }, [dispatch])

    const activeTab = chatBrandsStoreSlice?.activeTab || 'inbox'

    // Select the correct contacts list for the active tab
    const activeContacts = (() => {
        if (activeTab === 'sent')    return chatBrandsStoreSlice?.sentContacts
        if (activeTab === 'archive') return chatBrandsStoreSlice?.archiveContacts
        return chatBrandsStoreSlice?.inboxContacts
    })()

    return (
        <Fragment>
            <Sidebar
                store={chatBrandsStoreSlice}
                sidebar={sidebar}
                handleSidebar={handleSidebar}
                userSidebarLeft={userSidebarLeft}
                handleUserSidebarLeft={handleUserSidebarLeft}
                chatContacts={activeContacts}
                brandContacts={chatBrandsStoreSlice?.brandContacts}
                selectedUserID={id}
                activeTab={activeTab}
                onTabChange={handleTabChange}
                onMassMessageClick={handleMassMessageClick}
            />
            <div className='content-right'>
                <div className='content-wrapper'>
                    <div className='content-body'>
                        <Chat
                            store={chatBrandsStoreSlice}
                            activeTab={activeTab}
                            handleUser={handleUser}
                            handleSidebar={handleSidebar}
                            userSidebarLeft={userSidebarLeft}
                            handleUserSidebarRight={handleUserSidebarRight}
                            selectedUserID={id}
                            currentUser={chatBrandsStoreSlice?.brandUserProfile}
                            selectedUserBrandChat={chatBrandsStoreSlice?.selectedUserBrandChat}
                            selectedContactDetail={chatBrandsStoreSlice?.selectedContactDetail}
                            onTabChange={handleTabChange}
                            setMassMessageTrigger={(fn) => { massMsgHandlerRef.current = fn }}
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default AppChat